import React from "react";

const SubsectionList = ({
  subsections,
  selectedSubsection,
  onSubsectionSelect
}) => {
  return (
    <div className="flex flex-wrap gap-5 pt-5 pb-5 pl-16 text-[11px] font-normal border border-[#3BA2B91C] shadow-[0_0_25.2px_0_#3BA2B91F]">
      {subsections.length > 0 ? (
        subsections.map((sub) => (
          <div
            key={sub.subsectionId}
            className={`p-3 rounded-[2px] cursor-pointer border border-[#3BA2B929] shadow-[0_0_16px_0_#3BA2B91F] ${
              selectedSubsection === sub.subsectionId
                ? "bg-teal-50"
                : "bg-white"
            }`}
            onClick={() => onSubsectionSelect(sub.subsectionId)}
          >
            {sub.name}
          </div>
        ))
      ) : (
        <p className="text-gray-500">No subsections found.</p>
      )}
    </div>
  );
};

export default SubsectionList;
